import { c as _c } from "react/compiler-runtime";
import type { DashboardSecretApiKey } from '@onefootprint/request-types/dashboard';
import { CodeInline, Shimmer } from '@onefootprint/ui';
type KeyCellProps = {
  isPending: boolean;
  value: DashboardSecretApiKey;
};
const KeyCell = t0 => {
  const $ = _c(3);
  const {
    value,
    isPending
  } = t0;
  let t1;
  if ($[0] !== isPending || $[1] !== value) {
    t1 = isPending ? <Shimmer height="24px" width="280px" /> : <CodeInline isPrivate={true} disabled={!value.key}>{value.key ? value.key : value.scrubbedKey.replaceAll("*", "\u2022")}</CodeInline>;
    $[0] = isPending;
    $[1] = value;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default KeyCell;